import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-simple-layout',
  template: `
  <div class="d-flex flex-column">
    <main class="d-flex flex-row flex-grow-1">
      <div class="flex-grow-1">
        <router-outlet />
      </div>
    </main>
  </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet]
})
export class SimpleLayoutComponent { }
